import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';


const HomepageHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="bg-card border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-lg overflow-hidden bg-muted flex items-center justify-center">
              <Image
                src="/assets/images/IMG-20251119-WA0004-1767439147758.jpg"
                alt="Grid Balance Logo"
                className="max-w-full max-h-full object-contain"
              />
            </div>
            <div>
              <span className="text-xl font-heading font-bold text-foreground">Grid Balance</span>
              <p className="text-xs text-muted-foreground">Energy is the Key</p>
            </div>
          </div>
          
          <button
            onClick={() => navigate('/partner-finder')}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-smooth flex items-center gap-2 text-sm font-medium"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            Partner finden
          </button>
        </div>
      </div>
    </header>
  );
};

export default HomepageHeader;